import Tresorhome1 from '../../Media/homeimages/Tersor Gallant.webp'
import Tresorhome2 from '../../Media/homeimages/Tersor Gallant.webp'





const Tresorhomeimages =[
Tresorhome1,Tresorhome2
]

export default Tresorhomeimages;